import { Model } from '../model';

export class Setting extends Model {
    public id: number;
    public p: string;
    public v: string;
}
